import { ItemBoxDto } from '@marketplace-web/item-box/product-item-data'

import { ItemThumbnailSize } from '../constants/close-promotions'
import { UserPhotoDto } from './user-photo'
import { CurrencyAmountDto, CurrencyDto } from './currency'

export enum SortByOption {
  Relevance = 'relevance',
  PriceHighToLow = 'price_high_to_low',
  PriceLowToHigh = 'price_low_to_high',
  NewestFirst = 'newest_first',
}

export type CatalogFilterParams = {
  filters: {
    search_text?: string
    catalog_ids?: string
    price_from?: string
    price_to?: string
    currency?: string
    order?: SortByOption
    disable_search_saving?: boolean
  }
  dynamicFilters: Record<string, string>
}

export type GetClosetPromotionArgs = {
  page?: number
  perPage?: number
  excludedUserIds?: Array<number>
  searchSessionId?: string | null
  screenName?: string
  isPreview?: boolean
  catalogFilterParams?: CatalogFilterParams
}

export type ClosetUserModel = {
  id: number
  login: string
  photoUrl: string | null
  itemCount: number
  isFollowing: boolean
  feedbackReputation: number
  feedbackCount: number
  isBusinessUser: boolean
}

export type ClosetModel =
  | {
      user: ClosetUserModel
      items: Array<ClosetPromotionItemDto>
      showBanner: boolean
      isPreview?: boolean
    }
  | ClosetModelSvcVas

type ClosetPromotionItemPhotoThumbnailDto = {
  type: ItemThumbnailSize | string
  url: string
}

export type ClosetPromotionItemPhotoDto = {
  id: number
  url: string
  dominant_color_opaque: string
  thumbnails: Array<ClosetPromotionItemPhotoThumbnailDto>
  image_no: number
  is_main: boolean
}

export type ClosetPromotionUserDto = {
  id: number
  login: string
  photo: UserPhotoDto | null
  is_favourite: boolean
  item_count: number
  feedback_reputation: number
  feedback_count: number
}

export type ClosetPromotionItemDto = {
  id: number
  title: string
  user_id: number
  favourite_count: number
  is_favourite: boolean
  url: string
  photo: ClosetPromotionItemPhotoDto
  photos: Array<ClosetPromotionItemPhotoDto> | null
  price: CurrencyAmountDto
  service_fee?: CurrencyAmountDto | null
  total_item_price?: CurrencyAmountDto
  business_user?: boolean
  item_box?: ItemBoxDto | null
}

export type ClosetDto = {
  user: ClosetPromotionUserDto
  items: Array<ClosetPromotionItemDto>
}

export type PromotedClosetsListResp = {
  promoted_closets: Array<ClosetDto>
  page_info: {
    has_more: boolean
  }
}

export type ClosetPromotionUserDtoSvcVas = {
  id: number
  login: string
  photo_url?: string
  item_count: number
  is_following: boolean
  feedback_reputation: number
  feedback_count: number
  is_business_user: boolean
}

export type ClosetPromotionItemDtoSvcVas = {
  id: number
  title: string
  favourite_count: number
  is_favourite: boolean
  photos: Array<ClosetPromotionItemPhotoDto>
  price: CurrencyDto
  service_fee: CurrencyDto
  total_item_price: CurrencyDto
  item_box: ItemBoxDto
}

export type ClosetDtoSvcVas = {
  user: ClosetPromotionUserDtoSvcVas
  items: Array<ClosetPromotionItemDtoSvcVas>
}

export type ClosetModelSvcVas = {
  user: ClosetUserModel
  items: Array<ClosetPromotionItemDtoSvcVas>
  showBanner: boolean
  isPreview?: boolean
}

export type PromotedClosetsListRespSvcVas = {
  promoted_closets: Array<ClosetDtoSvcVas>
  page_info: {
    has_more: boolean
  }
}
